import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";

import { PledgeItemInterface } from "@/types/pledgeService";

export interface RenewPledgeItem extends PledgeItemInterface {
  downloanAmount: number;
}

interface RenewState {
  pledges: RenewPledgeItem[];
  cddInfo: any | null;
  cddType: string;
  setPledges: (pledges: RenewPledgeItem[]) => void;
  addPledge: (pledge: RenewPledgeItem) => void;
  updatePledge: (id: number, data: Partial<RenewPledgeItem>) => void;
  removePledge: (id: number) => void;
  setCDDInfo: (cddInfo: any) => void;
  setCDDType: (cddType: string) => void;
  reset: () => void;
}

const initialState = {
  pledges: [],
  cddInfo: null,
  cddType: "",
};

export const usePledgesStore = create<RenewState>()(
  devtools(
    persist(
      (set) => ({
        ...initialState,

        setPledges: (pledges): void =>
          set({
            pledges,
          }),

        addPledge: (pledge): void =>
          set((state) => {
            const alreadyExists = state.pledges.some((item) => item.id === pledge.id);

            if (alreadyExists) {
              return state;
            }

            return {
              pledges: [...state.pledges, pledge],
            };
          }),

        updatePledge: (id, data): void =>
          set((state) => ({
            pledges: state.pledges.map((item) =>
              item.id === id
                ? {
                    ...item,
                    ...data,
                  }
                : item,
            ),
          })),

        removePledge: (id): void =>
          set((state) => ({
            pledges: state.pledges.filter((item) => item.id !== id),
          })),

        setCDDInfo: (cddInfo): void =>
          set({
            cddInfo,
          }),

        setCDDType: (cddType): void =>
          set({
            cddType,
          }),

        reset: (): void => set(initialState),
      }),
      {
        name: "pledges-store",
      },
    ),
    {
      name: "PledgesStore",
    },
  ),
);
